/* ================================================== */
/* MENU → Sticky header
/* ================================================== */

$(document).ready(function() {
	var $header = $('#layout--header'),
		$nav    = $('.nav', $header);

	function stickyHeader() {
		if ((!breakpointXs && $(window).scrollTop() > $('#layout--network').outerHeight())
			|| (breakpointXs && $(window).scrollTop() > $('#layout--network').outerHeight() + $('.nav').outerHeight() + $('.brand__logo img').height()/2)) {
			$header.addClass('sticked');
		} else {
			$header.removeClass('sticked');
		}
	}

	$(window).on('resize orientationchange', function() {
		stickyHeader();
	});

	$(window).scroll(function() {
		stickyHeader();
	});
});